import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "comp sci ain't useless",
  "description": "",
  "published": "2019-05-01T00:00:00.000Z",
  "redirect_from": ["/blog/comp-sci-aint-useless/swizec/9064"],
  "categories": "Computer Science, Technical",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`You will often hear on the internet programmers say that their college degree was useless, that it taught them nothing, and that it's a waste of money.`}</p>
    <p>{`maybe`}</p>
    <p>{`Or maybe they just weren't paying attention.`}</p>
    <p>{`Knowledge is a tool. You can't use what you don't have.`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`Today in my dayjob as a web developer I used`}<br parentName="p"></br><br parentName="p"></br>{`- linked list traversal`}<br parentName="p"></br>{`- recursion`}<br parentName="p"></br>{`- the halting problem`}<br parentName="p"></br><br parentName="p"></br>{`Don't let anyone tell you computer science is useless in webdev 🤓`}</p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/1123482695793823744"
      }}>{`May 1, 2019`}</a></blockquote>
    <p>{`Just yesterday I used 3 different concepts from college.`}</p>
    <ul>
      <li parentName="ul">{`linked list traversal`}</li>
      <li parentName="ul">{`recursion`}</li>
      <li parentName="ul">{`the halting problem`}</li>
    </ul>
    <p>{`And I don't mean "`}<em parentName="p">{`I used code based on those principles"`}</em>{`. No, I used them for my own code because they were useful.`}</p>
    <h2 {...{
      "id": "the-halting-problem"
    }}>{`The halting problem`}</h2>
    <p>{`The halting problem came into play when I was helping the new guy implement a feature. He's building message receipts.`}</p>
    <p>{`We have a chatroom.`}</p>
    <p>{`How can the sender know that their message was received?`}</p>
    <p>{`Well, you use the `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Ping-pong_scheme"
      }}>{`ping pong scheme`}</a>{`. Each message is a ping. When you get a pong you know the message was received.`}</p>
    <p>{`But how do you know you're still waiting for a pong and the message wasn't lost?`}</p>
    <p>{`You don't. That's the `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Halting_problem"
      }}>{`halting problem`}</a>{`. Also known as an unsolvable decision problem. Or the most famous example of such.`}</p>
    <p>{`It is mathematically impossible to create a process that knows whether another process has finished or is still running.`}</p>
    <p>{`Only solution is to have a max timeout.`}</p>
    <p>{`If it don't pong in 30 seconds, it ain't ponging. 30 seconds is the default `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Transmission_Control_Protocol"
      }}>{`TCP timeout`}</a>{` btw.`}</p>
    <p>{`TCP `}<em parentName="p">{`also`}</em>{` uses a ping-pong scheme.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "750px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/4ac185b84b7c407f086e52b072e18aa3/1d69c/CPsvgpngg07c73.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "79.82062780269058%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'320\\'%20viewBox=\\'0%200%20400%20320\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M231%2014c-7%202-6%2010%202%2012%209%202%207%208-2%207-5-1-7%200-3%202%203%202%2010%201%2012-1%204-4%201-10-6-11l-4-3c0-3%203-4%207-3%204%200%206-2%203-2-4-1-7-2-9-1m83%203c0%203%200%204-1%203-2-2-7-1-9%201-5%205-1%2016%205%2015l6-1c2%200%202%200%202-11l-1-11c-2%200-2%201-2%204M62%2015c-5%202-7%2012-4%2017s15%206%2016%202c0-2%200-2-2-1-7%203-12-1-12-8s6-10%2012-7h2c0-4-7-5-12-3m37%205c-5%203-6%2011-2%2015%203%202%2012%202%2012-1l-5-1c-3%200-5%200-6-2l-1-2h6c6%200%207%200%207-2s-3-7-5-7h-6m20%200h-4c-2%200-2%200-2%208%201%209%203%2011%203%202%201-6%202-8%206-8%201%200%202%201%202%207%200%205%201%207%202%207%202%200%201-13-1-15s-4-2-6-1m29%200c-5%203-6%2011-2%2015%203%202%2012%202%2012-1h-4c-4%200-7-1-7-4l6-1h6v-3c-1-6-6-8-11-6m100%201c-8%205%201%2018%2010%2014%204-1%202-2-3-2s-6-1-6-3%200-2%206-2h6v-3c-2-6-8-8-13-4m27%200c7%2018%208%2019%2013%207l3-9c-2-1-4%201-5%206-3%207-3%207-6%200l-3-6c-2%200-2%200-2%202m48%201c-6%208%204%2019%2011%2012%203-3%203-10%200-13s-8-3-11%201M109%20146v127l1%2035v-28l1-28%20161%2029c2%200%202%200%200%202l-2%202%206-1%209-1h3v12l1%2012%201-126a3018%203018%200%2000-2-77v49l-8-4c-9-5-10-5-7-1v2l-82-14-80-15-1-34c0-24-1-7-1%2059m1%2014l1%2036%208-4%208-3a3795%203795%200%20010%204l161-28v-11h-4l-10%202h-4l2-2a23030%2023030%200%2000-161-31l-1%2037m108%2019l-81%2014-12%202%202%202%203%202h-10l-10-1v19l1%2020%208-3c8-5%209-5%206-1l-1%202h3l82-15%2079-13v-41l-70%2013m-11%2043l-81%2015h-2l2%202%203%202-8-1-9-1c-2%200-2%200-2%206l1%205%2080%2015c91%2016%2083%2015%2082%2012-2-3-1-3%207%201l8%203a894%20894%200%2000-1-73l-80%2014\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/4ac185b84b7c407f086e52b072e18aa3/ca0a1/CPsvgpngg07c73.webp 223w", "/static/4ac185b84b7c407f086e52b072e18aa3/75680/CPsvgpngg07c73.webp 445w", "/static/4ac185b84b7c407f086e52b072e18aa3/08b4d/CPsvgpngg07c73.webp 750w"],
              "sizes": "(max-width: 750px) 100vw, 750px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/4ac185b84b7c407f086e52b072e18aa3/e92b6/CPsvgpngg07c73.png 223w", "/static/4ac185b84b7c407f086e52b072e18aa3/e66bf/CPsvgpngg07c73.png 445w", "/static/4ac185b84b7c407f086e52b072e18aa3/1d69c/CPsvgpngg07c73.png 750w"],
              "sizes": "(max-width: 750px) 100vw, 750px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/4ac185b84b7c407f086e52b072e18aa3/1d69c/CPsvgpngg07c73.png",
              "alt": "CPsvgpngg07c73",
              "title": "CPsvgpngg07c73",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Look at that. A whole protocol we can mimic to implement message receipts. How wonderful. ✌️`}</p>
    <p>{`You'll think of ping-pong, halting, TCP, and unsolvable decision problems, if you've seen them before. `}<em parentName="p">{`"Ah! This problem is like that other problem!`}</em>{`.`}</p>
    <p>{`Pattern matching.`}</p>
    <h2 {...{
      "id": "linked-lists-and-recursion"
    }}>{`Linked lists and recursion`}</h2>
    <p>{`Linked lists and recursion broke my brain for many hours. There was a bug and I spent hours validating my implementation.`}</p>
    <p>{`Bug was actually in the data.`}</p>
    <p><a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Garbage_in,_garbage_out"
      }}>{`Garbage in garbage out`}</a>{`. Another compsci maxim.`}</p>
    <p>{`So how'd I use linked lists?`}</p>
    <p>{`We built a whole system for SMS drip campaigns over the years. It's like ConvertKit or Drip or ActiveCampaign but for SMS. Super neat and makes me wanna spin-off a separate company.`}</p>
    <p>{`But text campaigns are also the bane of my existence. I designed the system. I built it. I maintain it. 😅`}</p>
    <p>{`Text campaigns are built as linked lists. Technically graphs because there's branching and loops, but in practice they're often linked lists.`}</p>
    <p>{`Each node points to the next node. Each has a bunch of messages and a `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Domain-specific_language"
      }}>{`DSL`}</a>{` that specifies `}<em parentName="p">{`how`}</em>{` to GoNext.`}</p>
    <p>{`Supports skipping messages, delays, etc. It's neat.`}</p>
    <p>{`How do you implement that? Recursion. You interpret it like a programming language. You can think of it as a `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Finite-state_machine"
      }}>{`state machine`}</a>{` too.`}</p>
    <p>{`You are at a node. You do what the node says. You call yourself with the next node. You keep going until skip = false.`}</p>
    <p>{`But you won't think of linked lists, graphs, DSLs, recursion, graph-data-as-programming-language, and state machines unless you've heard of them before. `}<em parentName="p">{`"Ah! This problem is like that other problem!`}</em>{`.`}</p>
    <p>{`Pattern matching.`}</p>
    <h2 {...{
      "id": "in-conclusion"
    }}>{`In conclusion`}</h2>
    <p>{`You don't `}<em parentName="p">{`need`}</em>{` a computer science degree, or any degree, to get into web development. That's what I love about this field. It welcomes and accepts everyone.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Knowledge you've got you can use, knowledge you don't you can't`}</p>
    </blockquote>
    <p>{`But if you've got the degree, use it! Solve interesting problems. Grow.`}</p>
    <p>{`I too didn't need my college skills when I was just starting out as a $7/hour PDF-to-website converter.`}</p>
    <p>{`Happy hacking ✌️ ~Swizec`}</p>
    <p>{`PS: I understand I'm blessed that in Europe we believe college needs to be free to be any good. In USA this is the opposite. When you have to go into crushing debt to get a college degree ... well that's a different question. You don't `}<em parentName="p">{`need`}</em>{` one, but if you've got it and you paid for it, `}<strong parentName="p">{`find a hard enough job so you put that investment to use`}</strong>{`.`}</p>
    <p>{`Don't sell yourself short my friend`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      